import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type ProgressDisplayMode = 'percentage' | 'count'

type PercentageProgressBarProps = {
  percentage: number
  countLabel: number | string
  displayMode: ProgressDisplayMode
  onToggleDisplayMode: () => void
}

export const PercentageProgressBar = ({
  percentage,
  countLabel,
  displayMode,
  onToggleDisplayMode,
}: PercentageProgressBarProps) => {
  const roundedPercentage = Math.round(percentage * 10) / 10
  const percentageLabel = `${roundedPercentage.toFixed(0)}%`
  const displayLabel = displayMode === 'count' ? countLabel : percentageLabel
  const alternateLabel = displayMode === 'count' ? percentageLabel : countLabel
  let percentageColorClass = 'bg-destructive-foreground'
  if (percentage >= 50) percentageColorClass = 'bg-warning-foreground'
  if (percentage >= 75) percentageColorClass = 'bg-info-foreground'
  if (percentage === 100) percentageColorClass = 'bg-success-foreground'

  return (
    <div className='flex items-center gap-2 w-full'>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type='button'
            onClick={onToggleDisplayMode}
            className='min-w-10 text-right tabular-nums'
          >
            {displayLabel}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <div className='text-center'>
            <div>{alternateLabel}</div>
            <div className='text-xs text-muted-foreground'>Click to toggle</div>
          </div>
        </TooltipContent>
      </Tooltip>
      <div className='flex w-full h-3 min-w-14 rounded-sm border bg-muted overflow-hidden'>
        {percentage > 0 ? (
          <div
            className={`h-full ${percentageColorClass}`}
            style={{ width: `${percentage}%` }}
          />
        ) : null}
      </div>
    </div>
  )
}
